import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import { HEADER_COMPONENT_ID } from '../constants/constants';

/**
 * Checks if the given window is a popout and does not contain the header component.
 * @param targetWindow - The window to check. Defaults to the current window if not provided.
 * @returns True if the window is a popout and does not contain the header, false otherwise.
 */
export default function isPopoutWithoutHeader(targetWindow?: Window): boolean {
    return isPopout(targetWindow) && !targetWindow?.document.getElementById(HEADER_COMPONENT_ID);
}
